/**
 * Living Culture — automatic variant fallback
 *
 * When a customer selects a colour:
 * - Keep the current Size when that combination is in stock.
 * - Otherwise select the first in-stock Size for that colour.
 */

(() => {
  'use strict';

  if (window.__lcVariantAutoFallbackLoaded) return;
  window.__lcVariantAutoFallbackLoaded = true;

  document.addEventListener(
    'change',
    (event) => {
      const colourInput = event.target;

      if (
        !(colourInput instanceof HTMLInputElement) ||
        !colourInput.classList.contains('lc-image-swatch-input__input')
      ) {
        return;
      }

      if (
        colourInput.dataset.lcCurrentCombinationAvailable === 'true'
      ) {
        return;
      }

      const variantPicker = colourInput.closest('variant-selects');

      if (!variantPicker) return;

      let fallbackOptions;

      try {
        fallbackOptions = JSON.parse(
          colourInput.dataset.lcFallbackOptions || '[]'
        );
      } catch (error) {
        console.error(
          'Unable to read fallback variant options.',
          error
        );
        return;
      }

      if (!Array.isArray(fallbackOptions)) return;

      const colourOptionIndex =
        Number(colourInput.dataset.lcOptionPosition) - 1;

      const optionGroups = Array.from(
        variantPicker.children
      ).filter((element) => {
        return element.classList.contains('product-form__input');
      });

      fallbackOptions.forEach((optionValue, optionIndex) => {
        if (optionIndex === colourOptionIndex) return;

        const optionGroup = optionGroups[optionIndex];

        if (!optionGroup) return;

        const matchingRadio = Array.from(
          optionGroup.querySelectorAll('input[type="radio"]')
        ).find((input) => {
          return input.value === String(optionValue);
        });

        if (matchingRadio) {
          matchingRadio.checked = true;
          return;
        }

        const select = optionGroup.querySelector('select');

        if (select) {
          select.value = String(optionValue);
        }
      });
    },
    true
  );
})();